/**
 *
 * Function for Header State for Responsive (JS)
 *
 * @author Yusuke Manabe @ Space-Time Inc.
 * @version 2020-10-14
 *
 *
 */


(function() {
	const breakpoint  = 600;

	const sizeWidth           = 98; // as same as $size-width in "sass/_variables.scss"
	const sizeSideMargin      = 3;   // as same as $size-side-margin in "sass/_variables.scss"
	const sizeSideMarginPhone = 1.75;   // as same as $size-side-margin-phone in "sass/_variables.scss"
	const marginLeftInSearchAndLang = 1.7; // as same as '.search-and-lang {margin-left}' in "sass/_header.scss"
	const marginRightInSiteGlobalNavBar = -0.85; // as same as '..site-global-nav-bar {margin-right}' in "sass/_global-nav.scss"

	const headerElement = document.getElementsByClassName('site-header')[0];
	const headerMainElement     = headerElement.getElementsByClassName('site-header-main')[0];
	const brandingElement       = headerMainElement.getElementsByClassName('site-header-branding')[0];
	const searchAndLangElements = headerMainElement.querySelector('.search-and-lang.get-width-for-responsive');
	const GlobalNavElement      = headerMainElement.getElementsByClassName('site-global-nav-bar-inner')[0];

	let time;

	setHeaderState();

	setTimeout(function() {
		headerMainElement.style.opacity = 1;
	}, 10);


	window.addEventListener('resize', function() {
		clearTimeout(time);
		time = setTimeout(setHeaderState, 16);
	}, false);


//------------------------------------------------------------------------------

	function setHeaderState() {

		headerElement.classList.remove('wide');
		headerElement.classList.remove('middle');
		headerElement.classList.remove('narrow');

		const headerWidth        = getHeaderWidth();
		const brandingWidth      = brandingElement.getBoundingClientRect().width;
		const GlobalNavWidth     = GlobalNavElement.getBoundingClientRect().width;
		const searchAndLangWidth = searchAndLangElements.getBoundingClientRect().width;

		if (headerWidth - brandingWidth - searchAndLangWidth - rem(marginLeftInSearchAndLang) > GlobalNavWidth * 0.85) {
			headerElement.classList.add('wide');
		} else if (headerWidth - brandingWidth / 18.5 * 16 > GlobalNavWidth + rem(marginRightInSiteGlobalNavBar)) {
			headerElement.classList.add('middle');
		} else {
			headerElement.classList.add('narrow');
		}

	}

	function getHeaderWidth() {
		const margin = window.innerWidth > breakpoint ? sizeSideMargin : sizeSideMarginPhone ;
		return Math.min(rem(sizeWidth), window.innerWidth - rem(margin) * 2);
	}

	function rem(r) {
		const fontSize = getComputedStyle(document.documentElement).fontSize;
		return r * parseFloat(fontSize);
	}

}());
